import { Component, Inject, Input } from '@angular/core';
import { GoldenLayoutContainer } from 'ngx-golden-layout';
import GoldenLayout from 'golden-layout';
import { Crop, Field } from 'shared';

@Component({
  selector: 'app-field-editor',
  templateUrl: './field-editor.component.html',
  styleUrls: ['./field-editor.component.scss'],
})
export class FieldEditorComponent {
  @Input()
  selectedIndex = 0;

  tabs = [
    {
      id: 0,
      text: 'Cultures',
    },
    {
      id: 1,
      text: 'Archives',
    },
  ];

  field: Field;
  crop: Crop;

  constructor(
    @Inject(GoldenLayoutContainer) private container: GoldenLayout.Container,
  ) {
    // Access state
    this.field = container.getState().field;
    this.crop = container.getState().crop;
  }

  selectTab(e: any) {
    switch (e.itemData.id) {
      case 0:
        break;
      case 1:
        break;
      case 2:
        break;
    }
  }

}
